import {
    BULK_ADD_DRIVERID_TAGS_OPEN_MODAL,
    BULK_ADD_DRIVERID_TAGS_CLOSE_MODAL,
    BULK_ADD_DRIVERID_TAGS_VALIDATE_REQUEST,
    BULK_ADD_DRIVERID_TAGS_VALIDATE_RESULT,
    BULK_ADD_DRIVERID_TAGS_IMPORT_REQUEST,
    BULK_ADD_DRIVERID_TAGS_IMPORT_RESULT,
} from "Redux/actionTypes";

export const bulkAddDriverIdTagsOpenModal = (data) => ({
    type: BULK_ADD_DRIVERID_TAGS_OPEN_MODAL,
    payload: data
})

export const bulkAddDriverIdTagsCloseModal = () => ({
    type: BULK_ADD_DRIVERID_TAGS_CLOSE_MODAL
})

export const bulkAddDriverIdTagsValidateIds = (data) => ({
    type: BULK_ADD_DRIVERID_TAGS_VALIDATE_REQUEST,
    payload: data
})

export const bulkAddDriverIdTagsValidateIdsResult = (result) => ({
    type: BULK_ADD_DRIVERID_TAGS_VALIDATE_RESULT,
    payload: result
})

export const bulkAddDriverIdTagsImport = (data) => ({
    type: BULK_ADD_DRIVERID_TAGS_IMPORT_REQUEST,
    payload: data
})

export const bulkAddDriverIdTagsImportResult = (result) => ({
    type: BULK_ADD_DRIVERID_TAGS_IMPORT_RESULT,
    payload: result
})